<ng-container *ngIf="charts$ | async as charts; else loading">
  <cc-charts-list-toolbar
    [charts]="charts"
    [dashboard]="dashboard$ | async"
    [canAdd]="canAdd$ | async"
    [selectedCharts]="selectedCharts"
    (deleteSelected)="deleteSelectedCharts()"
    (addChart)="addChart()"
  ></cc-charts-list-toolbar>

  <ng-container *ngIf="charts.length; else empty">
    <div class="content">
      <cc-register>
        <cc-register-header
          [selected]="selectedCharts.size === charts.length"
          [displaySelectionCheckbox]="canAdd$ | async"
          (selectAll)="handleSelectAll(charts, $event)"
        >
          <cc-register-cell><span i18n>Name</span></cc-register-cell>
          <cc-register-cell><span i18n>Preview</span></cc-register-cell>
          <cc-register-cell><span i18n>Summary</span></cc-register-cell>
          <cc-register-cell><span i18n>Type</span></cc-register-cell>
          <cc-register-cell><span i18n>Source Template</span></cc-register-cell>
          <cc-register-cell><span i18n>Template Id</span></cc-register-cell>
          <cc-register-cell><span i18n>Created By</span></cc-register-cell>
          <cc-register-cell><span i18n>Created Date</span></cc-register-cell>
        </cc-register-header>
        <cc-register-row
          *ngFor="let chart of charts"
          [selected]="selectedCharts.get(chart._id)"
          [displaySelectionCheckbox]="canAdd$ | async"
          (select)="onSelectionToggle(chart, $event)"
          (click)="onChartClick(chart._id)"
        >
          <cc-register-cell>{{ chartUtilsService.getChartName(chart) || 'Untitled Chart' }}</cc-register-cell>
          <cc-register-cell
            ><cc-quantity-chart-thumbnail
              *ngIf="chart.kind === chartTypes.Quantity"
              [chart]="chart"
              class="chart-thumbnail"
            ></cc-quantity-chart-thumbnail
            ><cc-frequency-chart-thumbnail
              *ngIf="chart.kind === chartTypes.Frequency"
              [chart]="chart"
              class="chart-thumbnail"
            ></cc-frequency-chart-thumbnail>
            <cc-ratio-chart-thumbnail
              *ngIf="chart.kind === chartTypes.Ratio"
              [chart]="chart"
              class="chart-thumbnail"
            ></cc-ratio-chart-thumbnail>
          </cc-register-cell>
          <cc-register-cell>
            <ng-container *ngIf="chart.kind === chartTypes.Quantity">
              <span i18n>total: </span>
              {{ (chart.meta | async)?.totalQuantity }}
            </ng-container>
            <ng-container *ngIf="chart.kind === chartTypes.Frequency">
              <ng-container div *ngIf="chart.meta | async as meta">
                <span i18n>Last 30 days: </span>
                {{ meta.totalForms }} {{ meta.totalForms === 1 ? 'form' : 'forms' }}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="chart.kind === chartTypes.Ratio">
              <ng-container div *ngIf="chart.meta | async as meta">
                <span i18n>Last 30 days: </span>
                {{ meta.totalForms }} {{ meta.totalForms === 1 ? 'form' : 'forms' }}
              </ng-container>
            </ng-container>
          </cc-register-cell>
          <cc-register-cell class="text-capitalize">{{ chart.kind }}</cc-register-cell>
          <cc-register-cell
            ><a routerLink="/apps/{{ chart.templateId }}">{{ chart.template?.name }}</a></cc-register-cell
          >
          <cc-register-cell>{{ chart.template?.uniqueAppId }}</cc-register-cell>
          <cc-register-cell>
            <div class="d-flex align-items-center">
              <ng-container *ngIf="getUser(chart.createdBy) as user; else unknownUser">
                <cc-user-avatar [user]="user"></cc-user-avatar>
                <div class="ml-2">{{ user?.fullName }}</div>
              </ng-container>
              <ng-template #unknownUser>
                <cc-user-avatar [user]="{}"></cc-user-avatar>
                <div class="ml-2">{{ chart.createdBy }}</div>
              </ng-template>
            </div>
          </cc-register-cell>
          <cc-register-cell>{{ chart.createdAt | amDateFormat: 'll' }}</cc-register-cell>
        </cc-register-row>
      </cc-register>
    </div>
  </ng-container>
</ng-container>

<ng-template #empty>
  <div class="empty-chart">
    <img src="/assets/images/analytics/charts-background.svg" alt="" />
    <h3 class="h3 mt-4" i18n>Create your first Chart</h3>
    <p class="default-paragraph text-center mt-2">
      Charts can help visualise the form data recorded in the Templates section
    </p>
    <button
      type="button"
      (click)="addChart()"
      class="btn cc-btn-primary-constructive mt-3"
      ccSegmentCTA="Chart Add"
      data-cy="create-chart"
    >
      <i class="cc-icon cc-icon-plus"></i>
      <span>Add chart</span>
    </button>
  </div>
</ng-template>

<ng-template #loading>
  <div class="loading-spinner">
    <div class="cc-icon cc-icon-spinner-3x"></div>
  </div>
</ng-template>

<router-outlet></router-outlet>
